import React, { useState } from 'react';
import LoginPage from '../../pages/SignIn/SignInPage';
import TwoAuthenticationOtpVerify from './TwoAuthenticationOtpVerify';

const TwoAuthenticationPage = () => {
  const [step, setStep] = useState(1);

  const [formData, setFormData] = useState({
    email: '',
    newPassword: '',
  });

  return (
    <>
      {step === 1 ? (
        <LoginPage
          setStep={setStep}
          setFormData={setFormData}
        />
      ) : (
        <TwoAuthenticationOtpVerify
          formData={formData}
        />
      )}
    </>
  );
};

export default TwoAuthenticationPage;